<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn icon dark title="Back to payroll cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="payroll-processing-batch" color="white"></help-link>
                    <v-btn v-show="hasPayrollGenerated" @click="showReportsMenu" icon dark small title="Reports">
                        <v-icon>fa-solid fa-file</v-icon>
                    </v-btn>
                    <v-btn v-if="!hasPayrollGenerated&&hasEditRights" color="primary" :loading="loading" @click="generateAll" dark title="Process all valid records">
                        Process All
                    </v-btn>
                    <v-menu v-if="(hasEditRights||hasApproverRights)&&hasPayrollGenerated" offset-y v-model="menu_status" :disabled="isClosedCutOffPeriod||disableConditions">
                        <template v-slot:activator="{ on }">
                            <v-btn :color="overAllStatusColor" dark v-on="on" :loading="loading">
                                &nbsp;&nbsp;{{overAllStatus}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-if="hasEditRights&&hasPayrollGenerated&&validForCreation>0" :key="0" @click="generateAll" :title="`Process ${validForCreation} payroll`">
                                <v-list-tile-title small>Process ({{validForCreation}})</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="hasEditRights&&hasPayrollGenerated&&createdCount>0" :key="1" @click="showForReviewAll" :title="`Set ${createdCount} records to For Review`">
                                <v-list-tile-title>For Review ({{createdCount}})</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="hasApproverRights&&hasPayrollGenerated&&forReviewCount>0" :key="3" @click="showApproveAll" :title="`Approve ${forReviewCount} records`">
                                <v-list-tile-title>Approve ({{forReviewCount}})</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="hasApproverRights&&hasPayrollGenerated&&canBeRejectedCount>0" :key="4" @click="showRejectAll" :title="`Reject ${canBeRejectedCount} records`">
                                <v-list-tile-title>Reject ({{canBeRejectedCount}})</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="hasEditRights&&hasPayrollGenerated&&approvedCount>0" :key="2" @click="showCreditedAll" :title="`Set ${approvedCount} records to Credited`">
                                <v-list-tile-title>Credited ({{approvedCount}})</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>

            <v-alert v-if="error" :value="true" color="error" icon="error" outline class="mt-8">
                Error encountered. Please contact support.
            </v-alert>
            <v-alert v-if="isClosedCutOffPeriod" :value="true" color="warning" icon="warning" outline class="mt-8">
                This cutoff period is already closed. You will not be able to modify payroll data.
            </v-alert>
            <v-alert v-if="!loading&&hasMissingCompanyDetails" :value="true" color="warning" icon="warning" outline class="mt-8">
                Company details have not been set up yet. Please update them on the <span @click="$router.push('/company/account')"><u class="clickable"><b>Company Account</b></u> page.</span>
            </v-alert>

            <!-- summary  -->
            <v-card class="elevation-1 mt-5">
                <v-toolbar flat height="45px" @click="summaryVisible=!summaryVisible" class="clickable">
                    <span class="font-weight-bold primary--text">SUMMARY</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="summaryVisible" icon title="Minimize">
                        <v-icon>expand_less</v-icon>
                    </v-btn>
                    <v-btn v-if="!summaryVisible" icon title="Expand">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="summaryVisible">
                    <v-layout row wrap align-center class="section-layout">
                        <v-flex xs12 class="text-xs-left">
                            <v-layout row wrap>
                                <v-flex xs6 sm3>
                                    <div class="caption grey--text text--darken-1">Total Net Pay</div>
                                    <div class="subheading green--text text--darken-2 font-weight-bold">
                                        ₱{{ numFormat.formatNumber(totalNetPay) }}
                                    </div>
                                </v-flex>
                                <v-flex xs6 sm3>
                                    <div class="caption grey--text text--darken-1">Cutoff Coverage</div>
                                    <div class="subheading font-weight-bold">{{cutoffCoverage}}</div>
                                </v-flex>
                                <v-flex xs6 sm3>
                                    <div class="caption grey--text text--darken-1">Month-end</div>
                                    <div class="subheading font-weight-bold">
                                        <span v-if="IsMonthEndClosing" >Yes</span>
                                        <span v-else>No</span>
                                    </div>
                                </v-flex>
                                <v-flex xs6 sm3>
                                    <div class="caption grey--text text--darken-1">Quarter-end</div>
                                    <div class="subheading font-weight-bold">
                                        <span v-if="isQuarterEndClosing" >Yes</span>
                                        <span v-else>No</span>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap class="mt-1">
                                <v-flex xs12 sm12>
                                    <div class="caption grey--text text--darken-1 ml-1">Status</div>
                                    <div class="ml-0">
                                        <v-chip v-if="unProcessedCount>0" @click="search='Not Available'" small label class="caption font-weight-bold" title="Click to view all Not Available">
                                            {{unProcessedCount}} Not Available
                                        </v-chip>
                                        <v-chip v-if="createdCount>0" @click="search='Created'" small label class="caption font-weight-bold" title="Click to view all Created">
                                            {{createdCount}} Created
                                        </v-chip>
                                        <v-chip v-if="forReviewCount>0" @click="search='For Review'" small class="warning--text caption font-weight-bold" label title="Click to view all For Review">
                                            {{forReviewCount}} For Review
                                        </v-chip> 
                                        <v-chip v-if="rejectedCount>0" @click="search='Rejected'" small class="error--text caption font-weight-bold" label title="Click to view all Rejected">
                                            {{rejectedCount}} Rejected
                                        </v-chip> 
                                        <v-chip v-if="approvedCount>0" @click="search='Approved'" small class="green--text caption font-weight-bold" label title="Click to view all Approved">
                                            {{approvedCount}} Approved
                                        </v-chip> 
                                        <v-chip v-if="creditedCount>0" @click="search='Credited'" small class="primary--text caption font-weight-bold" label title="Click to view all Credited">
                                            {{creditedCount}} Credited
                                        </v-chip>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            
            <!-- payroll list -->
            <v-card class="elevation-1 mt-5">
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-100 mb-10':'wp-40 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search employee, team, or status" clearable single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile ? [] : headers"
                    :items="payroll_list_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    :hide-headers="isMobile"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        
                        <!-- MOBILE CARD VIEW -->
                        <tr v-if="isMobile">
                            <td :colspan="headers.length" class="pa-1">
                                <v-card class="elevation-1" @click="viewUserPayroll(props.item)">
                                    <v-toolbar flat height="42">
                                        <v-chip class="user-chip-container" small>
                                            <v-avatar>
                                                <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                            </v-avatar>
                                            {{props.item.name}}
                                        </v-chip>
                                        <v-spacer></v-spacer>                                        
                                    </v-toolbar>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Net Pay</div>
                                                    <div v-if="props.item.netPay" class="subheading font-weight-bold">{{numFormat.formatNumber(props.item.netPay)}}</div>
                                                    <div v-else>Not Available</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Employment</div>
                                                    <div :class="commonfn.getStatusColor(props.item.employmentStatus)">
                                                        {{ commonfn.getStatusDescription(props.item.employmentStatus) }} 
                                                    </div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Compensation</div>
                                                    <div :class="commonfn.getStatusColor(props.item.allocationStatus)">
                                                        {{ commonfn.getStatusDescription(props.item.allocationStatus) }} 
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Timesheet</div>
                                                    <div :class="commonfn.getStatusColor(props.item.timeReportStatus)">
                                                        {{ commonfn.getStatusDescription(props.item.timeReportStatus) }} 
                                                    </div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Payroll</div>
                                                    <div :class="commonfn.getStatusColor(props.item.status)">
                                                        {{ commonfn.getStatusDescription(props.item.status) }} 
                                                    </div>
                                                </v-flex>
                                                <v-flex xs4 @click.stop>
                                                    <div class="caption grey--text text--darken-1">Payslip</div>
                                                    <v-btn v-if="props.item.netPay" icon small @click="generatePayslipPDF(props.item, props.index)" :loading="loadingPdfIndex === props.index">
                                                        <v-icon>fas fa-file-pdf</v-icon>
                                                    </v-btn>
                                                    <div v-else>Not Available</div>
                                                 </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 sm12>
                                                    <div class="caption grey--text text--darken-1">Teams</div>
                                                    <team-chips :teams="props.item.teams"></team-chips>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>

                        <!-- DESKTOP TABLE VIEW -->
                        <tr v-else @click="viewUserPayroll(props.item)" class="clickable">
                            <td>
                                <v-chip class="m-0" small>
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.name}}
                                </v-chip>
                            </td>
                            <td>
                                <team-chips :teams="props.item.teams"></team-chips>
                            </td>
                            <td>
                                <span :class="commonfn.getStatusColor(props.item.employmentStatus)">
                                    {{commonfn.getStatusDescription(props.item.employmentStatus)}}
                                </span>
                            </td>
                            <td>
                                <span :class="commonfn.getStatusColor(props.item.allocationStatus)">
                                    {{commonfn.getStatusDescription(props.item.allocationStatus)}}
                                </span>
                            </td>
                            <td>
                                <span :class="commonfn.getStatusColor(props.item.timeReportStatus)">
                                    {{commonfn.getStatusDescription(props.item.timeReportStatus)}}
                                </span>
                            </td>
                            <td>
                                <span :class="commonfn.getStatusColor(props.item.status)">
                                    {{commonfn.getStatusDescription(props.item.status)}}
                                </span>
                            </td>
                            <td class="text-xs-right">
                                <b>{{props.item.netPay>0?numFormat.formatNumber(props.item.netPay):''}}</b>
                            </td>
                            <td @click.stop>
                                <v-btn 
                                    v-if="props.item.status>0"
                                    @click="generatePayslipPDF(props.item, props.index)" 
                                    icon 
                                    small 
                                    :loading="loadingPdfIndex === props.index"
                                >
                                    <v-icon>fas fa-file-pdf</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-dialog v-model="dialogReports" persistent width="600">
            <reports ref="reportsRef" :dialogReports.sync="dialogReports"></reports>
        </v-dialog>
        <v-dialog v-model="dialogProcessing" width="600" persistent>
            <batch-processing 
                ref="refBatchProcessingComp" 
                :dialogProcessing.sync="dialogProcessing"
                :processingText="processingText"
                :processingValue="processingValue"
                :processed="processed"
                :failedItems="failedItems"
                :loadingProcessing="loadingProcessing"
                ></batch-processing>
        </v-dialog>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
        <v-dialog v-model="dialogOkCancel" persistent width="550">
            <ok-cancel :msg="dialogOkCancelMsg" alignLeft="true" :dialogOkCancel.sync="dialogOkCancel" @ok="onOkCancel"></ok-cancel>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout>
</template>

<script>

import payrollApi from '@/api/payroll'
import commonfn from '@/common/functions'   //for refactor
import numFormat from '@/common/num_format'
import updateHistApi from '@/api/updateshistory'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import rowsPerPageItems from '@/constants/rows-per-page'
import { 
    getSort, 
    getSearchKeyword, 
    getRowsPerPage, 
    updateRowsPerPage, 
    updateSort, 
    updateSearchKeyword, 
    getExpandCollapseVisibility,
    updateExpandCollapseVisibility
} from '@/helpers/user-prefs'
import { hasEditRights, hasApproverRights } from '@/helpers/access-permissions'

export default {
    name: 'Payroll',
    metaInfo: {
        title: 'Payroll',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, generate payroll' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'reports': () => import('@/components/Payroll/PayrollReports'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'team-chips': () => import("@/components/Common/TeamsChip"),
        'preview': () => import('@/components/FilePreview/Preview'),
        'batch-processing': () => import('@/components/Common/BatchProcessingContent'),
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            numFormat,
            awsS3Helper,
            rowsPerPageItems,
            search: getSearchKeyword(routeName),
            summaryVisible: getExpandCollapseVisibility(routeName, 'payroll-details-summary'),
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Employee',align: 'left',value: 'name', width: '15%', sortable: true},
                {text: 'Teams',align: 'left',value: 'team',  width: '18%', sortable:true},
                {text: 'Employment',align: 'left',value: 'employmentStatus',  width: '10%', sortable:true},
                {text: 'Compensation',align: 'left',value: 'allocationStatus',  width: '10%', sortable:true},
                {text: 'Timesheet',align: 'left',value: 'timeReportStatus',  width: '10%', sortable:true},
                {text: 'Payroll',align: 'left',value: 'status',  width: '10%', sortable:true},
                {text: 'Net Pay',align: 'right',value: 'netPay',  width: '10%', sortable:true},
                {text: 'Payslip',align: 'left',value: '',  width: '5%', sortable:false},
            ],
            header_failed: [
                {text: 'Employee',align: 'left',value: 'firstName', width: '65%', sortable: false},
                {text: 'Employee Id',align: 'left',value: 'employeeId', width: '35%', sortable: false},
            ],
            error: false,
            errorMessage: '',
            y:null,
            x:null,
            loading: false,
            loadingProcessing: false,
            dialogProcessing: false,
            dialogPreview: false,
            mode: null,
            loadingPdfIndex: null,
            expand: false,
            snackbar: false,
            snackbarText: '', 
            processingText: '',
            processingValue: 0,
            loadingControlReport: false,
            menu_status: false,
            dialogReports: false,
            cutoff_period: [],
            payroll_list: [],
            company_details: null,
            processed: 0,
            failed: 0,
            failedItems: [],
            dialogOkCancel: false,
            dialogOkCancelMsg: null,
            okCancelFunction: null,
        }
    },
    methods: {
        onOkCancel() {
            if (typeof this.okCancelFunction === 'function') {
                this.okCancelFunction()
            }
            this.okCancelFunction = null
            this.dialogOkCancel = false
        },
        showForReviewAll() {
            this.dialogOkCancelMsg = `This action will set all <b>Created</b> records to <b>For Review</b>.<br> Do you want to proceed?`
            this.dialogOkCancel = true
            this.okCancelFunction = () => this.forReviewAll()
        },
        showApproveAll() {
            this.dialogOkCancelMsg = `This action will <b>Approve</b> all <b>For Review</b> records.<br> Do you want to proceed?`
            this.dialogOkCancel = true
            this.okCancelFunction = () => this.approveAll()
        },
        showRejectAll() {
            this.dialogOkCancelMsg = `This action will <b>Reject</b> all <b>For Review</b> and <b>Approved</b> records.<br> Do you want to proceed?`
            this.dialogOkCancel = true
            this.okCancelFunction = () => this.rejectAll()
        },
        showCreditedAll() {
            this.dialogOkCancelMsg = `This action will set all <b>Approved</b> records to <b>Credited</b>.<br> Do you want to proceed?`
            this.dialogOkCancel = true
            this.okCancelFunction = () => this.creditedAll()
        },
        showReportsMenu() {
            var data = {
                cutoffId: this.selectedCutoffId,
                fiscalYear: this.cutoff_period.fiscalYear,
                cutoffStart: this.cutoff_period.cutoffStart,
                cutoffEnd: this.cutoff_period.cutoffEnd,
                isMonthEndClosing: this.IsMonthEndClosing,
                isQuarterEndClosing: this.isQuarterEndClosing
            }
            this.$refs.reportsRef.setParam(data)
            this.dialogReports=true
        },
        async updateHistory(updateAction) {
            try {
                var data = {
                    pageQueryId: this.pageQueryId,
                    updateAction: updateAction
                }
                await updateHistApi.send(data)
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        async generatePayslipPDF(item, index) {
            try {
                this.loadingPdfIndex = index;
                var data = {
                    userId: item.userId,
                    cutOffId: this.selectedCutoffId
                }
                const response = await payrollApi.getPayslipUrl(data)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(item.userId, response.data.fileName, AWSS3DocumentType.Paylips)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loadingPdfIndex = null;
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loadingPdfIndex = null;
            }
        },
        async creditedAll() {
            try {
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0

                this.processed = 0
                this.failed = 0
                this.failedItems = []

                const incrementBy = this.approvedCount > 0 ? 100 / this.approvedCount : 0

                for (const item of this.payroll_list_filtered) {
                    const isApproved = item.status == commonfn.getStatusCode('Approved')

                    if (isApproved) {
                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${this.approvedCount}`;
                        this.processingValue += incrementBy;

                        const data = {
                            userId: item.userId,
                            cutOffId: this.selectedCutoffId
                        }

                        try {
                            await payrollApi.payrollCredited(data)
                            this.processed += 1
                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push(item)
                        }
                    }
                }

                await this.getPayrollList(false)
                await this.updateHistory(`Credited ${this.processed} item(s), ${this.failed} failed`)
                this.loadingProcessing = false
                this.processingText = 'Batch Processing Completed'
            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        async approveAll() {
            try {
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0

                this.processed = 0
                this.failed = 0
                this.failedItems = []

                const incrementBy = this.forReviewCount > 0 ? 100 / this.forReviewCount : 0

                for (const item of this.payroll_list_filtered) {
                    const isForReview = item.status == commonfn.getStatusCode('For Review')

                    if (isForReview) {
                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${this.forReviewCount}`;
                        this.processingValue += incrementBy;

                        const data = {
                            userId: item.userId,
                            cutOffId: this.selectedCutoffId
                        }

                        try {
                            await payrollApi.approve(data)
                            this.processed += 1
                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push(item)
                        }
                    }
                }

                await this.getPayrollList(false)
                await this.updateHistory(`Approved ${this.processed} item(s), ${this.failed} failed`);
                this.loadingProcessing = false
                this.processingText = 'Batch Processing Completed'
            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        async rejectAll() {
            try {
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0

                this.processed = 0
                this.failed = 0
                this.failedItems = []

                const incrementBy = this.canBeRejectedCount > 0 ? 100 / this.canBeRejectedCount : 0

                for (const item of this.payroll_list_filtered) {
                    const isForReview = item.status == commonfn.getStatusCode('For Review')
                    const isApproved = item.status == commonfn.getStatusCode('Approved')

                    if (isForReview || isApproved) {
                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${this.forReviewCount}`;
                        this.processingValue += incrementBy;

                        const data = {
                            userId: item.userId,
                            cutOffId: this.selectedCutoffId
                        }

                        try {
                            await payrollApi.reject(data)
                            this.processed += 1
                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push(item)
                        }
                    }
                }

                await this.getPayrollList(false)
                await this.updateHistory(`Rejected ${this.processed} item(s), ${this.failed} failed`);
                this.loadingProcessing = false
                this.processingText = 'Batch Processing Completed'
            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        async generateAll() {
            try {
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0
                this.failedItems = []
                this.processed = 0
                this.failed = 0
                const incrementBy = 100 / this.validForCreation

                for (const item of this.payroll_list_filtered) {
                    const isApproved = item.allocationStatus == commonfn.getStatusCode('Approved')
                    const isTimeApproved = item.timeReportStatus == commonfn.getStatusCode('Approved')
                    
                    const isEmploymentValid = [
                        commonfn.getStatusCode('Active'),
                        commonfn.getStatusCode('Resigned'),
                        commonfn.getStatusCode('Terminated')
                    ].includes(item.employmentStatus)

                    const isStatusValid = [
                        commonfn.getStatusCode('Not Available'),
                        commonfn.getStatusCode('Created'),
                        commonfn.getStatusCode('Rejected')
                    ].includes(item.status)
                    
                    if (isApproved && isTimeApproved && isStatusValid && isEmploymentValid) {
                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${this.validForCreation}`
                        this.processingValue += incrementBy

                        const data = {
                            userId: item.userId,
                            cutOffId: this.selectedCutoffId
                        }

                        try {
                            await payrollApi.generateByUser(data)
                            this.processed += 1
                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push(item)
                        }
                    }
                }

                await this.getPayrollList(false)
                await this.updateHistory(`Generated ${this.processed} item(s), ${this.failed} failed`);
                this.loadingProcessing = false
                this.processingText = 'Batch Processing Completed'
            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        async forReviewAll() {
            try {
                this.loadingProcessing = true
                this.dialogProcessing = true
                this.processingValue = 0

                this.processed = 0
                this.failed = 0
                this.failedItems = []

                const incrementBy = this.createdCount > 0 ? 100 / this.createdCount : 0

                for (const item of this.payroll_list_filtered) {
                    const isTimeApproved = item.timeReportStatus == commonfn.getStatusCode('Approved')
                    const isStatusCreated = item.status == commonfn.getStatusCode('Created')

                    if (isTimeApproved && isStatusCreated) {
                        this.processingText = `Processing ${this.processed + this.failed + 1} of ${this.createdCount}`
                        this.processingValue += incrementBy

                        const data = {
                            userId: item.userId,
                            cutOffId: this.selectedCutoffId
                        }

                        try {
                            await payrollApi.forReview(data)
                            this.processed += 1
                        } catch (err) {
                            this.failed += 1
                            this.failedItems.push(item)
                        }
                    }
                }

                await this.getPayrollList(false)
                await this.updateHistory(`For Review ${this.processed} item(s), ${this.failed} failed`);
                this.loadingProcessing = false
                this.processingText = 'Batch Processing Completed'
            } catch (error) {
                this.error = true
                this.errorMessage = error
                this.loadingProcessing = false
            }
        },
        viewUserPayroll(data) {
            const activeStatuses = [
                commonfn.getStatusCode('Active'),
                commonfn.getStatusCode('Resigned'),
                commonfn.getStatusCode('Terminated')
            ];

            // Employment status check
            if (!activeStatuses.includes(data.employmentStatus)) {
                return this.showSnackbar('Invalid employment status');
            }

            // Compensation approval check
            if (data.allocationStatus !== commonfn.getStatusCode('Approved')) {
                return this.showSnackbar('Compensation not approved');
            }

            // Timesheet approval check
            if (data.timeReportStatus !== commonfn.getStatusCode('Approved')) {
                return this.showSnackbar('Timesheet not approved');
            }

            // All good → proceed
            this.$router.push(`/payroll/generate/${this.selectedCutoffId}/${data.userId}`);
        },
        showSnackbar(message) { 
            this.snackbar = true
            this.snackbarText = message
            return false
        },
        async getPayrollList(show_loading) {
            try {
                this.loading = show_loading
                const response = await payrollApi.getByCompany(this.selectedCutoffId)
                if (response && response.status == 200) {
                    this.payroll_list = response.data.items
                    this.cutoff_period = response.data.cutoffItem
                    this.company_details = response.data.company
                }
                this.loading = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getPayrollList(false)

            //invoke updateHistoryRef appendData
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Processing Summary'
        })

        this.getPayrollList(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        },
        summaryVisible(newVal) {
            updateExpandCollapseVisibility(this.$route.name, 'payroll-details-summary', newVal)
        },
    },
    computed: {
        pageQueryId() {
            return `payrollprocessing${this.selectedCutoffId}`
        },
        payroll_list_filtered() {
            let temp = this.payroll_list;

            // search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase();

                temp = temp.filter(item => {
                    const nameMatch = item.name.toLowerCase().includes(searchLower)                    
                    const teamsMatch = Array.isArray(item.teams)
                        ? item.teams.join(', ').toLowerCase().includes(searchLower)
                        : false

                    const statusDescription = commonfn.getStatusDescription(item.status)
                    const statusMatch = statusDescription.toLowerCase().includes(searchLower)

                    return nameMatch || teamsMatch || statusMatch;
                })
            }

            return temp;
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        selectedCutoffId() {
            return this.$route.params.id
        },
        commentsData() {
            if (this.payroll_list) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.payroll,
                    notificationTypeId: notificationTypes.payroll_summary
                }
            }
        },
        openCutOffPeriod() {
            if (this.cutoff_period) return this.cutoff_period.status==commonfn.getStatusCode('Open')
        },
        cutoffCoverage() {
            if (this.loading) return;
             
            const start = this.$moment(this.cutoff_period.cutoffStart);
            const end = this.$moment(this.cutoff_period.cutoffEnd);

            const sameYear = start.year() === end.year();
            const sameMonth = start.month() === end.month() && sameYear;

            if (sameMonth) {
                // Aug 1–15, 2025
                return `${start.format('MMM D')} - ${end.format('D, YYYY')}`;
            }

            if (sameYear) {
                // Aug 25 – Sep 10, 2025
                return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
            }

            // Dec 26, 2025 – Jan 10, 2026
            return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
        },
        hasPayrollGenerated() {
            return this.payroll_list_filtered.filter(item=> {
                return item.status==commonfn.getStatusCode('Created') ||
                item.status==commonfn.getStatusCode('For Review') ||
                item.status==commonfn.getStatusCode('Approved') ||
                item.status==commonfn.getStatusCode('Rejected') ||
                item.status==commonfn.getStatusCode('Credited')
            }).length
        },
        creditedCount() {
             return this.payroll_list_filtered.filter(item=> {
                return item.status==commonfn.getStatusCode('Credited')
            }).length
        },
        unProcessedCount() {
            return this.payroll_list_filtered.length-this.hasPayrollGenerated
        },
        forReviewCount() {
            return this.payroll_list_filtered.filter(item => {
                return item.status == commonfn.getStatusCode('For Review')
            }).length
        },
        rejectedCount() {
            return this.payroll_list_filtered.filter(item => {
                return item.status == commonfn.getStatusCode('Rejected')
            }).length
        },
        canBeRejectedCount() {
            return this.payroll_list_filtered.filter(item => {
                return item.status == commonfn.getStatusCode('For Review') ||
                        item.status == commonfn.getStatusCode('Approved') ||
                        item.status == commonfn.getStatusCode('Credited')
            }).length
        },
        createdCount() {
            return this.payroll_list_filtered.filter(item => {
                return item.status == commonfn.getStatusCode('Created')
            }).length
        },
        approvedCount() {
            return this.payroll_list_filtered.filter(item => {
                return item.status == commonfn.getStatusCode('Approved')
            }).length
        },
        IsMonthEndClosing() {
            if (this.cutoff_period) return this.cutoff_period.isMonthEndClosing
        },
        isQuarterEndClosing() {
            if (this.cutoff_period) return this.cutoff_period.isQuarterEndClosing
        },
        isClosedCutOffPeriod() {
            if (this.cutoff_period) return this.cutoff_period.status==commonfn.getStatusCode('Closed')
        },
        validForCreation() {
            return this.payroll_list_filtered.filter(item => {
                return item.allocationStatus==commonfn.getStatusCode('Approved') &&
                        item.timeReportStatus==commonfn.getStatusCode('Approved') &&
                        (
                            item.status==commonfn.getStatusCode('Not Available') ||
                            item.status==commonfn.getStatusCode('Created') ||
                            item.status==commonfn.getStatusCode('Rejected')
                        )
            }).length
        },
        totalNetPay() {
            if (!this.loading && this.payroll_list_filtered.length>0)
                return this.payroll_list_filtered
                            .map(x=>x.netPay)
                            .reduce((prev,next)=>prev+next)
            else return 0
        },
        overAllStatus() {
            if (this.payroll_list.length==0) return 'In Progress'
            return this.payroll_list.length==this.creditedCount?'Completed':'In Progress'
        },
        overAllStatusColor() {
            return this.overAllStatus=='Completed'?'primary':'orange'
        },
        hasMissingCompanyDetails() {
            if (this.company_details) {
                return !this.company_details.companyTIN ||
                        !this.company_details.branchCode
            }
            return true
        },
        disableConditions(){
            return this.validForCreation == 0
                    && this.createdCount == 0
                    && this.approvedCount == 0
                    && this.forReviewCount == 0
                    && this.canBeRejectedCount == 0
        }
    }
}
</script>
<style scoped>
.section-layout-mobile {
    padding:0px 0px 0px 5px;
}
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>